export enum CustomerType {
  CORPORATE = 'CORPORATE',
  INDIVIDUAL = 'INDIVIDUAL',
}

class UserInfo {
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  hashedEmail: string;
  lastLogin: string;
  phoneNumber: string;
  customerType: CustomerType;
  omniUserId: number;
  customerId?: number | null;

  constructor(
    username: string,
    firstname: string,
    lastname: string,
    email: string,
    hashedEmail: string,
    lastLogin: string,
    phoneNumber: string,
    customerType: CustomerType,
    omniUserId: number,
    customerId?: number | null,
  ) {
    this.username = username;
    this.firstname = firstname;
    this.lastname = lastname;
    this.email = email;
    this.hashedEmail = hashedEmail;
    this.lastLogin = lastLogin;
    this.phoneNumber = phoneNumber;
    this.customerType = customerType;
    this.omniUserId = omniUserId;
    this.customerId = customerId;
  }
}

export { UserInfo };
